import * as React from 'react'

import { Box, Grid, Text } from '@chakra-ui/react'

type Item = {
  label: string
  value: React.ReactNode
}

export const DescriptionList: React.FC<{ items: Item[] }> = ({ items }) => {
  return (
    <Grid
      gridTemplateColumns="220px 1fr"
      overflow="hidden"
      borderWidth="1px"
      borderColor="Border.midEmphasis"
      borderRadius="radiiLg"
    >
      {items.map((item, index) => {
        const borderBottomWidth = index === items.length - 1 ? undefined : '1px'
        return (
          <React.Fragment key={item.label}>
            <Box
              padding="4"
              borderBottomWidth={borderBottomWidth}
              borderBottomColor="Border.lowEmphasis"
              backgroundColor="Surface.neutralLow"
            >
              <Text textStyle="headerSm" color="Text.midEmphasis">
                {item.label}
              </Text>
            </Box>
            <Box
              minWidth={0}
              padding="4"
              borderBottomWidth={borderBottomWidth}
              borderBottomColor="Border.lowEmphasis"
            >
              {item.value}
            </Box>
          </React.Fragment>
        )
      })}
    </Grid>
  )
}
